import { enableMarvel } from "./marvel-neat";
export { enableMarvel };
